<template>
  <div class="md-layout-item md-size-100 md-medium-size-100">
    <md-card>
      <md-card-header
        class="md-card-header-icon"
      >
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Limitations of GPR Operating in Scanned Slabs
        </h4>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-50 md-medium-size-100">
            <h3>Limitations of GPR Operating in Scanned Slabs</h3>
            <p>Some common limitations encountered when using GPR: (Reference: Concrete Structure Investigations,
The Concrete Sawing and Drilling Association &amp;amp; Hilti)</p>
            <md-button @click="openContent" class="md-info">Download</md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
  export default {
    data(){

    },
    methods: {
      openContent(){
        // this.downloadClicked = true;
        window.open("https://drive.google.com/file/d/1lqzNCZ2PzCMkxrNGeGZ96eciRDob-iSD/view?usp=sharing", '_blank')
      }
    }
  }
</script>
<style media="screen" lang="scss">
</style>
